<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table ref='estimateTable' :config="config"
          :api-getlist="getList"
          hide-upsert @clone="clone">
          <template slot="headerActions">
            <v-btn color="pink" to="/estimate">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import { mapState } from 'vuex'
import { clone as cloneEstimate } from '@/api/estimate'
import { getList } from '@/api/base_entity'

export default {
  data () {
    return { config }
  },
  computed: mapState('app', ['protocol']),
  watch: {
    protocol () {
      this.$refs.estimateTable.getData(true)
    }
  },  
  methods: {
    getList (entity, filters, pagination) {
      if (this.protocol.id !== -1) {
        filters.protocol_id = this.protocol.id
      }
      return getList('estimate', filters, pagination)
    },
    async clone(item) {
      const ret = await this.$root.$confirm.open('Confirm clone', 'Are you sure to CLONE this item?', { color: 'orange' })
      if (ret) {
        cloneEstimate(item.id).then( () => {
          this.$root.$emit('openSnackbar', {
            message: ' Estimate cloned correctly',
            color: 'success'
          })

          this.$refs.estimateTable.getData()

        })
        .catch(e => {
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the estimate clone. ' +
              e && e.response ? e.response.data.message : 'Error',
            color: 'error'
          })
        })
      }
    },
    closeClone() {
      this.confirm_clone_dialog = false;
    }
  }
}
</script>
